import React, { useState } from 'react';

// Top 10 financial aid/bursary institutions
const topFinancialInstitutions = [
  {
    name: 'NSFAS (National Student Financial Aid Scheme)',
    type: 'Financial Aid',
    applyUrl: 'https://my.nsfas.org.za/'
  },
  {
    name: 'Funza Lushaka Bursary',
    type: 'Bursary',
    applyUrl: 'https://www.funzalushaka.doe.gov.za/'
  },
  {
    name: 'Allan Gray Orbis Foundation Fellowship',
    type: 'Bursary/Scholarship',
    applyUrl: 'https://www.allangrayorbis.org/'
  },
  {
    name: 'Department of Health Bursaries',
    type: 'Bursary',
    applyUrl: 'https://www.gov.za/about-government/government-programmes/health-bursaries'
  },
  {
    name: 'Sasol Bursary',
    type: 'Bursary',
    applyUrl: 'https://www.sasolbursaries.com/'
  },
  {
    name: 'Shoprite Bursary',
    type: 'Bursary',
    applyUrl: 'https://bursaries.shoprite.co.za/'
  },
  {
    name: 'Old Mutual Bursary',
    type: 'Bursary',
    applyUrl: 'https://www.oldmutual.co.za/about-us/bursaries/'
  },
  {
    name: 'Standard Bank Bursary',
    type: 'Bursary',
    applyUrl: 'https://www.standardbank.com/southafrica/personal/about-us/careers/graduate-opportunities/bursaries'
  },
  {
    name: 'FNB Bursary',
    type: 'Bursary',
    applyUrl: 'https://www.fnb.co.za/about-fnb/careers/bursaries.html'
  },
  {
    name: 'Capitec Bursary',
    type: 'Bursary',
    applyUrl: 'https://www.capitecbank.co.za/about-us/careers/career-opportunities/bursaries/'
  }
];

// All financial institutions for search (can be expanded)
import { financialInstitutions } from './financialInstitutionsData';

const FinancialInstitutions = () => {
  const [search, setSearch] = useState('');

  // Heading and note
  const headingStyle = {
    color: '#fff',
    fontSize: 32,
    fontWeight: 700,
    marginBottom: 8,
    marginTop: 0,
    textShadow: '0 2px 8px #0007'
  };
  const noteStyle = {
    color: '#fff',
    fontSize: 16,
    marginBottom: 32,
    textShadow: '0 2px 8px #0007'
  };

  const filtered = search.trim()
    ? financialInstitutions.filter(inst => inst.name.toLowerCase().includes(search.toLowerCase()))
    : topFinancialInstitutions;

  return (
    <div style={{ maxWidth: 700, margin: '40px auto', padding: 24 }}>
      <h1 style={headingStyle}>Financial Aid & Bursaries</h1>
      <div style={noteStyle}><b>Note:</b> Only the top 10 financial aid/bursary institutions are listed below by default. Use search to find more.</div>
      <input
        type="text"
        placeholder="Search for a financial institution..."
        value={search}
        onChange={e => setSearch(e.target.value)}
        style={{ width: '100%', padding: 12, borderRadius: 8, border: '1px solid #c7a16c', margin: '24px 0', fontSize: 18 }}
      />
      <div style={{ color: '#a05a2c', marginBottom: 18, fontSize: 15 }}>
        <b>Note:</b> Only the top 10 financial aid/bursary institutions are listed below by default. Use search to find more.
      </div>
      <ul style={{ listStyle: 'none', padding: 0 }}>
        {filtered.length === 0 && <li style={{ color: '#888', marginTop: 32 }}>No financial institutions found.</li>}
        {filtered.map(inst => (
          <li key={inst.name} style={{ marginBottom: 28, background: '#fff', borderRadius: 12, boxShadow: '0 2px 12px #eee', padding: 24, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div>
              <div style={{ fontWeight: 700, fontSize: 22, color: '#2d4b2d' }}>{inst.name}</div>
              <div style={{ fontSize: 16, color: '#a05a2c', marginTop: 4 }}>{inst.type}</div>
            </div>
            <a
              href={inst.applyUrl || "#"} onClick={e => { if (!inst.applyUrl) { e.preventDefault(); alert('No application URL available for this institution.'); } }}
              target="_blank"
              rel="noopener noreferrer"
              style={{ padding: '12px 28px', borderRadius: 8, background: '#a05a2c', color: '#fff', fontWeight: 700, fontSize: 18, textDecoration: 'none' }}
            >
              Apply Now
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FinancialInstitutions;
